import { render } from "./ContentPopupBulkEditing.vue?vue&type=template&id=4c85d7fc&scoped=true"
import script from "./ContentPopupBulkEditing.vue?vue&type=script&lang=js"
export * from "./ContentPopupBulkEditing.vue?vue&type=script&lang=js"

import "./ContentPopupBulkEditing.vue?vue&type=style&index=0&id=4c85d7fc&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c85d7fc"]])

export default __exports__